import { Injectable } from '@angular/core';
import { DccAdapter } from './dcc.adapter';
import { Observable } from 'rxjs';
import { OccEndpointsService } from '@spartacus/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class OccDccAdapter implements DccAdapter {
  constructor(
    protected http: HttpClient,
    protected occ: OccEndpointsService
  ) {}
  getData(productData: any): Observable<any> {
    const url = this.occ.buildUrl('dcc');
    const headers = new Headers({
      'Content-Type': 'application/json',
    });
    return this.http.post(url, productData, { responseType: 'text' });
  }
}
